module.exports = __webpack_public_path__ + "img/icon-arrow-left-grey.asset.3473f49b.svg";